// INITIALIZE KUBE
$K.init();

// SUPPORT IE
import './modernizr__svg.js';

// KUBE FRAMEWORK
import './kube.min.js';

// JS MODULES
import './alert.js';
import './calendar-carousel.js';
import './home-hero.js';
import './nav.js';
import './news.js';
import './tabs-coach.js';
import './slideshow.js';
import './videoHero.js';
import './livestream.js';


// import 'tabbyjs/dist/js/tabby.polyfills.min.js';
